export class ReviewsPagination {
  button: Element;
  container: Element;
  loader: Element;
  url: string;

  constructor(button: Element, container: Element, loader: Element) {
    this.button = button;
    this.container = container;
    this.loader = loader;
    this.url = this.button ? this.button.getAttribute("href") : null;
  }

  changeUrlPagination() {
    const total = ~~this.button.getAttribute("data-total-reviews");

    const urlObj = new URL(this.url)
    const search_params = urlObj.searchParams;
    let page = ~~search_params.get("page");

    if (total <= (page * 10)) {
      this.button.classList.add("hidden");
    }

    page = page + 1;
    search_params.set("page", String(page));
    urlObj.search = search_params.toString();

    this.url = urlObj.toString();
  }

  fetchXhr() {
    fetch(this.url)
      .then(response => response.text())
      .then(data => {
        this.container.innerHTML += data;
        this.toggleLoader();
      });
  }

  toggleLoader() {
    this.loader.classList.toggle("hidden");
  }

  updateUrl() {
    this.button.setAttribute("href", this.url);
  }

  clickHandler() {
    if (this.button) {
      this.button.addEventListener("click", event => {
        event.preventDefault();

        this.toggleLoader();
        this.fetchXhr();
        this.changeUrlPagination();
        this.updateUrl();
      })
    }
  }
}
